export default __webpack_public_path__ + "static/media/AXA_FI.b8dc3197.png";